// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CodeCircleIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "CodeCircle/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 1.667A8.336 8.336 0 0 0 1.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667Zm-2.892 9.558a.629.629 0 0 1 0 .883.618.618 0 0 1-.441.184.618.618 0 0 1-.442-.184l-1.667-1.666a.629.629 0 0 1 0-.884l1.667-1.666a.629.629 0 0 1 .883 0 .629.629 0 0 1 0 .883L5.883 10l1.225 1.225Zm4.3-2.925-1.666 3.892a.627.627 0 0 1-.817.325.62.62 0 0 1-.325-.825L10.267 7.8a.614.614 0 0 1 .816-.325.633.633 0 0 1 .325.825Zm4.034 2.142-1.667 1.666a.618.618 0 0 1-.442.184.618.618 0 0 1-.441-.184.629.629 0 0 1 0-.883L14.117 10l-1.225-1.225a.629.629 0 0 1 0-.883.629.629 0 0 1 .883 0l1.667 1.666a.629.629 0 0 1 0 .884Z"
}));
export default CodeCircleIcon;